module.exports = __webpack_public_path__ + "img/popularity-checked-en.cc8cc58d.png";